import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import type { IGlobalSignalrGroupResponse } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";
import { useState } from "react";

const getGlobalSignalrGroupsUUID = createUUID();

export const useGlobalSignalrViewModel = () => {
  const stateManager = useComponentState();
  const [globalSignalrGroups, setGlobalSignalrGroups] = useState<
    IGlobalSignalrGroupResponse[]
  >([]);

  const getGlobalSignalrGroups = () => {
    stateManager.abort(getGlobalSignalrGroupsUUID);
    return stateManager.run(async () => {
      const response = await taskService.globalSignalrGroups.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        setGlobalSignalrGroups(response.data);
      }
      return response;
    }, getGlobalSignalrGroupsUUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    globalSignalrGroups,
    getGlobalSignalrGroups,
  };
};
